<template>
  <div>
    <acheader></acheader>
    <div class="row mainbody">
      <div class="col-lg-2 col-md-4 col-sm-12">
        <orgsidebar></orgsidebar>
      </div>
      <div class="col-lg-10 col-md-8 col-sm-12">
        <div class="moduleWrapper form" v-if="org!==null">
          <div class="moduleCard">
            <div class="row">
              <div class="field col-md-6">
                <label class="text-dark">Company Name:</label><br />
                <input class="mb-0" type="text" id="companyName" aria-label="Enter company name here" v-model.trim="org.OrganizationName">
              </div>
              <div class="field col-md-6">
                <label class="text-dark">Contact Name:</label><br />
                <input class="mb-0" type="text" id="contactName" aria-label="Enter company contact name here" v-model.trim="org.ContactName">
              </div>
            </div>
         

            <div class="address row">
              <div class="field col-md-6 mt-3">
                <label class="text-dark">Street Address 1:</label><br />
                <input class="mb-0" type="text" id="streetAddress1" aria-label="Enter street address line 1 here" v-model.trim="org.Address1.StreetAddress1">
              </div>
              <div class="field col-md-6 mt-3">
                <label class="text-dark">Street Address 2:</label><br />
                <input class="mb-0" type="text" id="streetAddress2" aria-label="Enter street address line 2 here" v-model.trim="org.Address1.StreetAddress2">
              </div>
              <div class="field col-md-6 mt-3">
                <label class="text-dark">City:</label><br />
                <input class="mb-0" type="text" id="city" aria-label="Enter city here" v-model.trim="org.Address1.City">
              </div>
              <div class="field col-md-6 mt-3">
                <label class="text-dark">State:</label><br />
                <select class="mb-0" id="state" aria-label="Choose your state here" v-model="org.Address1.State">

                  <option value="AL">Alabama</option>
                  <option value="AK">Alaska</option>
                  <option value="AZ">Arizona</option>
                  <option value="AR">Arkansas</option>
                  <option value="CA">California</option>
                  <option value="CO">Colorado</option>
                  <option value="CT">Connecticut</option>
                  <option value="DE">Delaware</option>
                  <option value="DC">District Of Columbia</option>
                  <option value="FL">Florida</option>
                  <option value="GA">Georgia</option>
                  <option value="HI">Hawaii</option>
                  <option value="ID">Idaho</option>
                  <option value="IL">Illinois</option>
                  <option value="IN">Indiana</option>
                  <option value="IA">Iowa</option>
                  <option value="KS">Kansas</option>
                  <option value="KY">Kentucky</option>
                  <option value="LA">Louisiana</option>
                  <option value="ME">Maine</option>
                  <option value="MD">Maryland</option>
                  <option value="MA">Massachusetts</option>
                  <option value="MI">Michigan</option>
                  <option value="MN">Minnesota</option>
                  <option value="MS">Mississippi</option>
                  <option value="MO">Missouri</option>
                  <option value="MT">Montana</option>
                  <option value="NE">Nebraska</option>
                  <option value="NV">Nevada</option>
                  <option value="NH">New Hampshire</option>
                  <option value="NJ">New Jersey</option>
                  <option value="NM">New Mexico</option>
                  <option value="NY">New York</option>
                  <option value="NC">North Carolina</option>
                  <option value="ND">North Dakota</option>
                  <option value="OH">Ohio</option>
                  <option value="OK">Oklahoma</option>
                  <option value="OR">Oregon</option>
                  <option value="PA">Pennsylvania</option>
                  <option value="RI">Rhode Island</option>
                  <option value="SC">South Carolina</option>
                  <option value="SD">South Dakota</option>
                  <option value="TN">Tennessee</option>
                  <option value="TX">Texas</option>
                  <option value="UT">Utah</option>
                  <option value="VT">Vermont</option>
                  <option value="VA">Virginia</option>
                  <option value="WA">Washington</option>
                  <option value="WV">West Virginia</option>
                  <option value="WI">Wisconsin</option>
                  <option value="WY">Wyoming</option>

                </select>
              </div>
              <div class="field col-md-6 mt-3">
                <label class="text-dark">Zip:</label><br />
                <input type="text" id="zip" aria-label="Enter zip code here" v-model.trim="org.Address1.Zip">
              </div>
            </div>
            <div class="row mt-2">
              <div class="field col-12 mb-5">
                <label class="text-dark">Organization Image</label><br />
                <div class="row">
                  <div class="col-12">
                    <img v-bind:src="org.FullImage" width="50" height="50" onerror="this.src='/pool.svg'" />&nbsp;&nbsp;
                    <input type='file' id='fileinput' ref="tfiles" class='w25 ib mb-0' @change="getFile" />
                  </div>
                </div>
              </div>
            </div>

            <div class="col-12 text-right mt-3">
              <button class="btn btn-primary btn-short fixmargin" @click="doSave">Save</button>
            </div>
          </div>
        </div>
      </div>
    <div class="clearfix"></div></div><acfooter></acfooter>
  </div>
</template>

<script>
  import acheader from "../../layout/Header.vue"
  import acfooter from "../../layout/Footer.vue"
  import orgsidebar from "../../layout/Organization/Sidebar.vue"

  export default {
      name: "OrgEdit",
      components:{acheader,acfooter,orgsidebar},
      data() {
        return {
          fdata: null,
          org: null
        }
      },
      methods: {
        doSave() {

          var fields={
            OrganizationName: this.org.OrganizationName,
            OrganizationID: this.org.OrganizationID,
            StreetAddress1: this.org.Address1.StreetAddress1,
            StreetAddress2: this.org.Address1.StreetAddress2,
            City: this.org.Address1.City,
            State: this.org.Address1.State,
            Zip: this.org.Address1.Zip,
            Phone: this.org.Address1.Phone,
            ContactName: this.org.ContactName,
            NameFormat: 0
          };
          
          if (this.fdata != null) {
            fields.CircleImage = this.fdata.split(',')[1];
          }

          this.apiCommand([
             {
               Operation: "Organization",
               Function: "Edit",
               Fields: fields
             }
          ]).then(r=>{
            if (r!==null) {
              var cr = JSON.parse(r.CommandResult);
              if (cr.returnObjects[0].returnObject==="OK") {
               
                this.doPage(true).then(r=>{
                  this.bootstrapOrg(this.org.OrganizationID);
                  this.org.FullImage="https://attachments.simmersion.com/"+this.org.OrganizationID+".png?r="+Math.random(0,100000);
                  this.popDialog(0, "Organization Edited Successfully");
                  this.$forceUpdate();
                })
              }
              else {
                this.popDialog(1, cr.returnObjects[0].returnObject);
              }
            }
          });
        },
        getFile() {
             
          var r = new FileReader();
          var self=this;
          r.onload = function (e) {
            self.fdata = e.target.result;
          }
          r.readAsDataURL(this.$refs["tfiles"].files[0]);
        }
      },
      mounted() {
        this.doPage().then(r=>{
          this.bootstrapOrg(this.$route.params.id);

          // Copy the object to allow for a proper save
          this.org = JSON.parse(JSON.stringify(this.sdata.activeorg));
          if (this.org.NameFormat===null) {
            this.org.NameFormat=0;
          }
        });
      }
   }
</script>
